module.exports = __webpack_public_path__ + "static/img/son17_active.e1aa7430.png";